import {
  Component,
} from "@angular/core";
import { ReactFacade } from "../../facades/react.facade";

@Component({
  selector: "ngx-user-menu",
  template: '<div [id]="id" class="user-menu"><div class="placeholder"></div></div>',
  styles: [`.user-menu {
  display: flex;
  position: relative;
  margin-left: 8px;
  margin-right: 8px;
  min-width: 32px;
  min-height: 32px;
}

.placeholder {
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 50%;
  background-color: #f2f1f7;
  margin-left: 8px;
  width: 32px;
  height: 32px;
}
`],
})
export class UserMenuComponent {
  id = "ItsB0GH3muANYIe9HOSd";

  constructor(private reactFacade: ReactFacade) {}

  ngAfterViewInit() {
    this.handleRendering();
  }

  handleRendering() {
    this.reactFacade.initializeApp$().subscribe(() => {
      document.dispatchEvent(
        new CustomEvent("unmount-user-menu", { detail: { rootId: this.id } }),
      );

      const event = new CustomEvent("user-menu", {
        detail: { rootId: this.id },
      });
      document.dispatchEvent(event);
    });
  }


  ngOnDestroy() {
    document.dispatchEvent(
      new CustomEvent("unmount-user-menu", { detail: { rootId: this.id } }),
    );
  }
}
